import { TourMediaDataViewModel } from '@api/index';
import { Images } from '@components/galleries/GalleryHeroImages/GalleryHeroImages';

export const formatTourImages = (
  images?: TourMediaDataViewModel[],
  name?: string
): Images[] =>
  images?.map((image, index) => ({
    url: image?.url || '/static/images/setur-static.jpg',
    alt: `${name} ${index + 1}`,
  })) || [];
